export default __webpack_public_path__ + "static/media/light.40515cc0.jpg";